"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var AbstractReleaseComment_1 = require("./AbstractReleaseComment");
/**
 * @author JMr
 */


var PriceComment =
/*#__PURE__*/
function (_AbstractReleaseComme) {
  _inherits(PriceComment, _AbstractReleaseComme);

  /**
   * Price Comment
   * @param id identifier of comment
   * @param releaseId
   * @param priceZoneId if scoped for price zone
   * @param userId id of creator
   * @param username name of creator
   * @param productId
   * @param text
   * @param persistent indicating whether should be stored for later use in different release items
   * @param deleteOn validity date
   */
  function PriceComment(id, releaseId, priceZoneId, userId, username, productId, text, persistent, deleteOn) {
    var _this;

    _classCallCheck(this, PriceComment);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceComment).call(this, id, releaseId, userId, username, text, persistent, deleteOn));
    _this.id = id;
    _this.releaseId = releaseId;
    _this.priceZoneId = priceZoneId;
    _this.userId = userId;
    _this.username = username;
    _this.productId = productId;
    _this.text = text;
    _this.persistent = persistent;
    _this.deleteOn = deleteOn;
    return _this;
  }

  return PriceComment;
}(AbstractReleaseComment_1.AbstractReleaseComment);

exports.PriceComment = PriceComment;

PriceComment.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PriceComment.name);
  return {
    id: builder.str('id'),
    releaseId: builder.str('releaseId'),
    priceZoneId: builder.opt(builder.str('priceZoneId')),
    userId: builder.str('userId'),
    username: builder.opt(builder.str('username')),
    productId: builder.str('productId'),
    text: builder.str('text').withDescription({
      multiline: true
    }),
    persistent: builder.opt(builder.bool('persistent')),
    deleteOn: builder.opt(builder.date('deleteOn', DateParser_1.DateParser.ISO_PATTERN))
  };
}();